import { gql } from "@apollo/client";

const WELCOME_MAIL = gql`
  mutation WelcomeMutation($name: String!) {
    welcome(name: $name)
  }
`;

export default WELCOME_MAIL;
